import Inquiries from '~/components/maud/inquiries';

const InquiriesPage = () => <Inquiries />;

export default InquiriesPage;
